import { Container, Box, Header, Button, Grid, SpaceBetween } from '@cloudscape-design/components';

import { DashboardViewLayout } from '../../components/DashboardViewLayout';
import { useNavigate } from '@tanstack/react-router';

export default function View() {
  const navigate = useNavigate();

  return (
    <DashboardViewLayout
      breadcrumbs={[{ text: 'Home', href: '' }]}
      headerVariant="high-contrast"
      maxContentWidth={800}
      header={
        <Container
          header={
            <Header
              description="Welcome to Real Time Feedback's AI Analytics platform!"
              variant="h1"
            >
              AI Analytics @ Real Time Feedback
            </Header>
          }
        >
          <SpaceBetween size="xs">
            <Box variant="p">This is the home page for Real Time Feedback's AI Analytics.</Box>
            <Box variant="p">
              We provide a variety of AI-powered business tools, described below.
            </Box>
          </SpaceBetween>
        </Container>
      }
    >
      <div>
        <Container
          variant="stacked"
          header={
            <Header
              actions={
                <Button
                  variant="normal"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate({ to: '/dashboard/places' });
                  }}
                >
                  View
                </Button>
              }
              description="Review monitoring and contact identification"
              variant="h3"
            >
              Review Monitoring
            </Header>
          }
        >
          <Box variant="p">
            Monitor reviews across the globe. Supercharged with AI, our tool will help you identify
            the best opportunities.
          </Box>
        </Container>
        <Container
          variant="stacked"
          header={
            <Header
              actions={
                <SpaceBetween size="xs" direction="horizontal">
                  <Button
                    variant="primary"
                    href="/dashboard/scorecard/create"
                    onFollow={(e) => {
                      e.preventDefault();
                      navigate({ to: '/dashboard/scorecard/create', search: { tab: 'single' } });
                    }}
                  >
                    Create
                  </Button>
                  <Button
                    variant="normal"
                    href="/dashboard/scorecard"
                    onFollow={(e) => {
                      e.preventDefault();
                      navigate({ to: '/dashboard/scorecard' });
                    }}
                  >
                    View
                  </Button>
                </SpaceBetween>
              }
              description="Create and manage review scorecards"
              variant="h3"
            >
              Review Scorecards
            </Header>
          }
        >
          <Box variant="p">
            Create and manage review scorecards. AI-powered, our tool will help you measure business
            performance from the customer's perspective.
          </Box>
        </Container>
      </div>
    </DashboardViewLayout>
  );
}
